import React, { useEffect, useRef, useState } from "react";
import { GoTriangleDown } from "react-icons/go";
import { useTranslation } from "react-i18next";
import { GrLanguage } from "react-icons/gr";
import { Link } from "react-router-dom";
import { applyDocumentLanguage, getLanguageDirection } from "../../i18n/config";

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const { t, i18n } = useTranslation();

  const url = window.location.href;

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const openHandler = (lang) => {
    setIsOpen(false);

    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    applyDocumentLanguage(lang);
  }

  useEffect(() => {
    applyDocumentLanguage(localStorage.getItem("lang") || i18n.language);
  }, [])

  const handleDocumentClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative text-center flex">
      <button
        onClick={toggleDropdown}
        type="button"
        className="inline-flex items-center text-center text-gray-900 rounded-lg hover:shadow-lg dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        id="dropdownMenuIconButton"
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <GrLanguage color="black" cursor={"pointer"} size={20} title="Localization" />
        <GoTriangleDown color="black" />
      </button>

      {isOpen && (
        <div
          className={`z-10 absolute mt-[1.7rem] w-20 divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700 dark:divide-gray-600 ${
            getLanguageDirection(i18n.language) === "rtl" ? "left-0 -mx-8" : "right-0 -mx-3"
          }`}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="dropdownMenuIconButton"
        >
          <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
            <li>
              <Link
                to={url}
                onClick={() => openHandler("ps")}
                className="block text-center w-full text-md font-bold cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-black"
              >
                {t("pashto")}
              </Link>
            </li>
            <li>
              <Link
                to={url}
                onClick={() => openHandler("pr")}
                className="block text-center w-full text-md font-bold cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-black"
              >
                {t("dari")}
              </Link>
            </li>
            <li>
              <Link
                to={url}
                onClick={() => openHandler("en")}
                className="block text-center w-full text-md font-bold cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-black"
              >
                {t("English")}
              </Link>
            </li>
          </ul>

        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
